<template>
    <div id="admin_excluded_placements_page" class="container-fluid">
        <h4 class="margin-left10 margin-bottom20 pull-left">Client: {{ client.name || 'All Clients' }}</h4>
        <button @click="resetModalData" type="button" class="btn btn-secondary main-button pull-right" data-toggle="modal" data-target="#add_new_placement">+ Add New Placement</button>

        <div class="modal fade" id="add_new_placement" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Add New Placement</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <input id="new_placement" v-model="new_placement" type="text" class="form-control">
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn" data-dismiss="modal">Cancel</button>
                        <button @click="addNewPlacement" :disabled="!new_placement" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <v-client-table :data="tableData" :columns="columns" :options="options">
            <div slot="placement_to_exclude" slot-scope="props">
                <div v-if="!props.row.edit_mode">{{ props.row.placement_to_exclude }}</div>
                <input v-if="props.row.edit_mode" type="text" class="form-control edit-excluded-placement" :value="props.row.placement_to_exclude">
            </div>

            <div slot="actions" slot-scope="props" class="text-right">
                <button v-if="!props.row.edit_mode" @click="toggleEditMode(props.row.id)" class="btn btn-info reverse">Edit</button>
                <button v-if="props.row.edit_mode" @click="save(props.row.id, $event)" class="btn btn-success reverse">Save</button>
                <button v-if="props.row.edit_mode" @click="toggleEditMode(props.row.id)" class="btn cancel-editing">Cancel</button>
                <button v-if="!props.row.edit_mode" @click="remove(props.row.id)" class="btn btn-danger reverse">Delete</button>
            </div>
        </v-client-table>

        <div class="text-center">
            <button @click="$router.go(-1)" type="button" class="btn btn-info">Back</button>
        </div>
    </div>
</template>

<script>
    export default {
        created() {
            if (this.$route.params.id) {
                axios.get(`/api/clients/${this.$route.params.id}`).then(response => {
                    this.client = response.data;
                });
            }

            this.fetchServerData();
        },

        data() {
            return {
                client: {},
                new_placement: '',
                columns: ['placement_to_exclude', 'actions'],
                tableData: [],
                options: {
                    headings: {
                        placement_to_exclude: 'Excluded Placements',
                        actions:              ''
                    },
                    sortable: ['placement_to_exclude'],

                    perPage: 20,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} placements|{count} placements|One placement',
                        filter: '',
                        filterPlaceholder: 'Search placements...',
                        noResults: 'No matching placements'
                    },
                    skin: 'table'
                }
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get(`/api/admin/excluded-placements?client_id=${this.$route.params.id || ''}`)
                ])
                .then(axios.spread(excludedPlacements => {
                    _.each(excludedPlacements.data, item => {
                        item.edit_mode = false;
                    });

                    this.tableData = excludedPlacements.data;
                }));
            },

            resetModalData() {
                this.new_placement = '';
            },

            addNewPlacement() {
                $('#add_new_placement').modal('hide');

                axios.post(`/api/admin/excluded-placements?client_id=${this.$route.params.id || ''}`, {
                    placement: this.new_placement
                }).then(() => {
                    this.$notify({
                        type: 'success',
                        text: 'Placement has been successfully added.'
                    });

                    this.fetchServerData();
                });
            },

            toggleEditMode(id) {
                const index = _.findIndex(this.tableData, {id: id});

                if (index > -1) {
                    this.tableData[index].edit_mode = !this.tableData[index].edit_mode;
                }
            },

            save(id, event) {
                const newPlacement = $(event.target).closest('tr').find('.edit-excluded-placement').val();
                const index        = _.findIndex(this.tableData, {id: id});

                if (index > -1) {
                    this.tableData[index].edit_mode = false;
                }

                axios.put(`/api/admin/excluded-placements/${id}?client_id=${this.$route.params.id || ''}`, {
                    placement: newPlacement
                }).then(() => {
                    this.$notify({
                        type: 'success',
                        text: 'Placement has been successfully updated.'
                    });

                    this.fetchServerData();
                });
            },

            remove(id) {
                this.confirmation('Are you sure you want to delete this placement?', () => {
                    axios.delete(`/api/admin/excluded-placements/${id}?client_id=${this.$route.params.id || ''}`).then(() => {
                        this.$notify({
                            type: 'success',
                            text: 'Placement has been successfully deleted.'
                        });

                        this.fetchServerData();
                    });
                });
            }
        }
    }
</script>

<style lang="scss">
    #admin_excluded_placements_page {
        .edit-excluded-placement {
            width: auto;
            height: 3.4rem;
        }

        .cancel-editing {
            padding: 0.8rem 1.65rem;
        }

        input[type="radio"] {
            position: relative;
            top: .1rem;
        }

        .VueTables__search {
            display: none;
        }

        .VueTables__table {
            table-layout: fixed;
        }
    }
</style>
